import { GenericBackendResponse } from '../genericBackendResponse';
import {
	CreatePensionPlanTransferDto,
	PensionPlanTransfer
} from './interfaces/PensionPlanTransfer';

const createPensionPlanTransfer = async (
	token: string,
	transferData: CreatePensionPlanTransferDto
): Promise<GenericBackendResponse<PensionPlanTransfer>> => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/pension-plan-transfers/create-transfer`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			},
			body: JSON.stringify(transferData)
		}
	);

	return response.json();
};

export default createPensionPlanTransfer;
